import posthog from 'posthog-js';
import { POSTHOG_HOST, POSTHOG_KEY } from '@config/config';

// Stashed landing-site distinct_id for cross-domain handoff.
// Must be aliased *after* posthog.identify() so a person profile exists.
let _landingDistinctId: string | null = null;

export function initPostHog(): void {
  if (typeof window === 'undefined' || !POSTHOG_KEY) return;
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST ?? 'https://us.i.posthog.com',
    person_profiles: 'identified_only',
    defaults: '2026-01-30',
    advanced_enable_surveys: true,
  });

  // Stash the landing page distinct_id so we can alias it after identify().
  const params = new URLSearchParams(window.location.search);
  _landingDistinctId = params.get('ph_did');
}

/**
 * Merge the landing-site anonymous session with the now-identified app user.
 * Call this immediately after posthog.identify().
 */
export function aliasLandingSession(): void {
  if (_landingDistinctId && _landingDistinctId !== posthog.get_distinct_id()) {
    posthog.alias(_landingDistinctId);
    _landingDistinctId = null;
  }
}

export default posthog;
